
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.5 20.5h16v2a1 1 0 01-1 1h-14a1 1 0 01-1-1v-2zM16.694 7.635a4.5 4.5 0 111.648 8.318","stroke":"#50657c","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M2.5 20.5a44.786 44.786 0 01.777-8.732 2.005 2.005 0 00-.756-2L.7 8.4a.5.5 0 01.3-.9h15.64c1.33 3.28 1.86 7.89 1.86 13h-16zm9-17.916V1.5A1 1 0 009.793.793 1 1 0 009.5 1.5v1.1c-2.167.42-3.81 2.213-4.95 4.9h12.09c-1.101-2.723-2.764-4.525-5.14-4.916v0z","stroke":"#50657c","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M10.5 18.5c1.105 0 2-2.015 2-4.5s-.895-4.5-2-4.5-2 2.015-2 4.5.895 4.5 2 4.5z","stroke":"#50657c","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    